import { ButtonERP, OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPen, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  useActivoById,
  useGetActivoAmortizaciones,
  useGetDetalleAmortizacionActivoById,
} from "api/Activo.hook"
import { deleteActivo } from "api/Activo.service"
import { useGetCoeficienteAmortizacion } from "api/CoeficienteAmortizacion.hook"
import DeleteModal from "common/components/Modal/DeleteModal"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { ProgressSpinner } from "primereact/progressspinner"
import { Tooltip } from "primereact/tooltip"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import { ACTIVOS } from "routes/RoutePaths"
import { TIPO_CREACION } from "../../../../../api/Types/TipoCreacion"
import { EstadoActivos } from "../components/EstadoActivos"
import { ModalAmortizar } from "./components/ModalAmortizar"
import { TabsDetail } from "./components/TabsDetail"

const initialStatusModalAmortizar = { show: false }

export const ActivoId = () => {
  const { t } = useTranslation()
  const { coeficientesAmortizacion } = useGetCoeficienteAmortizacion()
  const { activoId } = useParams<{ activoId: string }>()
  const { activoByIdData, activoByIdIsLoading } = useActivoById(activoId)
  const { detalleAmortizacionActivo, detalleAmortizacionActivoRefetch } =
    useGetDetalleAmortizacionActivoById(activoId)
  const { activoAmortizacionesRefetch } = useGetActivoAmortizaciones(
    activoId as string
  )
  const history = useHistory()
  const [isModalAmortizarOpen, setIsModalAmortizarOpen] = useState<{
    show: boolean
    isEdit?: boolean
  }>(initialStatusModalAmortizar)
  const [showDelete, setShowDelete] = useState<boolean>(false)
  if (activoByIdIsLoading) {
    return (
      <div className='tw-flex tw-h-screen tw-w-screen tw-bg-black tw-bg-opacity-30'>
        <ProgressSpinner className='!tw-my-auto !tw-mx-auto' />
      </div>
    )
  }

  const hanldeDeleteActive = async () => {
    if (activoId) {
      const { status } = await deleteActivo(activoId)
      if (status === STATUSCORRECT) {
        notification.success({ body: `${t("nsAssets.modalDelete.sucessMsg")}` })
        history.push(ACTIVOS)
      }
    }
  }

  return (
    <div className='tw-w-full tw-h-full tw-overflow-y-hidden'>
      <div className='tw-flex tw-justify-between tw-bg-white tw-py-4 tw-px-6'>
        <div className='tw-flex tw-items-center tw-gap-3'>
          <ButtonERP
            customize={{
              type: "transparent",
              size: "md",
            }}
            icon={<FontAwesomeIcon icon={["fal", "arrow-left"]} />}
            onClick={() => history.goBack()}
          />
          <span className='tw-text-2xl tw-font-medium tw-leading-10'>
            {activoByIdData?.nombre}
          </span>
          {activoByIdData?.tipoCreacion === TIPO_CREACION.IMPORTADO && (
            <span>
              <Tooltip
                target='.tooltip-info'
                content={`${t("nsAssets.detailHeader.importedAsset")}`}
                position='bottom'
                className='tooltip-cartera-header'
              />
              <span className='tooltip-info tw-w-12 tw-h-full tw-flex tw-justify-center tw-items-center'>
                <FontAwesomeIcon
                  icon={["fal", "file-import"]}
                  className='tw-w-5 tw-h-5 tw-text-info-100'
                />
              </span>
            </span>
          )}
        </div>
        <div className='tw-flex tw-gap-x-3'>
          <div className='tw-place-content-center'>
            <EstadoActivos
              t={t}
              variant={activoByIdData?.estado}
            />
          </div>

          {activoByIdData?.esAmortizable &&
            !detalleAmortizacionActivo?.concepto && (
              <ButtonERP
                label={`${t("nsAssets.detailHeader.amortize")}`}
                customize={{
                  type: "secondary",
                  size: "md",
                }}
                className='tw-w-fit'
                onClick={() => setIsModalAmortizarOpen({ show: true })}
              />
            )}

          <OptionsMenuStorybook
            id='activos-amortizaciones-options-menu'
            items={[
              {
                title: `${t("nsAssets.detailHeader.menu.editAmortizacion")}`,
                hasRedirect: false,
                show: Boolean(detalleAmortizacionActivo?.id),
                action: () =>
                  setIsModalAmortizarOpen({ show: true, isEdit: true }),
                icon: faPen,
              },
              {
                title: `${t("nsAssets.detailHeader.menu.delete")}`,
                hasRedirect: false,
                action: () => setShowDelete(true),
                icon: faTrashCan,
                className: "tw-text-danger",
                iconClassName: "tw-text-danger",
              },
            ]}
            position='right'
          />
        </div>
      </div>
      <TabsDetail
        openAmortizar={() => setIsModalAmortizarOpen({ show: true })}
      />
      <ModalAmortizar
        isOpen={isModalAmortizarOpen.show}
        onCancel={() => setIsModalAmortizarOpen({ show: false, isEdit: false })}
        onSuccess={() => {
          setIsModalAmortizarOpen({ show: false })
          notification.success({
            body: `${
              isModalAmortizarOpen?.isEdit
                ? t("nsAssets.modalAmortize.sucessEditMsg")
                : t("nsAssets.modalAmortize.sucessGenerateMsg")
            }`,
          })
          detalleAmortizacionActivoRefetch()
          activoAmortizacionesRefetch()
        }}
        coeficientesAmortizacion={coeficientesAmortizacion}
      />
      <DeleteModal
        visible={showDelete}
        onHide={() => setShowDelete(false)}
        size='small'
        iconType='remesas'
        buttonLabel={t("nsAssets.modalDelete.confirmLabel")}
        title={t("nsAssets.modalDelete.title")}
        message={t("nsAssets.modalDelete.message")}
        onConfirm={hanldeDeleteActive}
      />
    </div>
  )
}
